import { SizeProps } from './size';
import { ArrayToType } from '../utils';

export const text: { [key in SizeProps]: { fontSize: number; lineHeight: number } } = {
  xs: {
    fontSize: 11,
    lineHeight: 14,
  },
  sm: {
    fontSize: 12,
    lineHeight: 16,
  },
  md: {
    fontSize: 14,
    lineHeight: 18,
  },
  lg: {
    fontSize: 16,
    lineHeight: 20,
  },
  xl: {
    fontSize: 18,
    lineHeight: 22,
  },
};

export const TextTagArray = [
  'div',
  'p',
  'span',
  'b',
  'strong',
  'em',
  'label',
  'a',
  'h1',
  'h2',
  'h3',
  'h4',
  'h5',
  'h6',
] as const;
export type TextTagType = ArrayToType<typeof TextTagArray>;
